import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from "@angular/core";

import {
  ModalDismissReasons,
  NgbActiveModal,
  NgbModal,
  NgbModalOptions,
} from "@ng-bootstrap/ng-bootstrap";
import { EventFormCustomFormType } from "../../events-screen/event-page-models/event-form-custom-form-type";
import { BaseDiscountModel } from "../discount-models/BaseDiscountModel";

@Component({
  selector: "discount-generic-parent-events-page-main-modal-container",
  templateUrl: "./discount-management-form-main-modal-container.component.html",
  styleUrls: ["./discount-management-form-main-modal-container.component.scss"],
})
export class DiscountManagementFormMainModalContainerComponent
  implements OnInit
{
  public static readonly modalOptions: NgbModalOptions = {
    backdropClass: "user-management-form-main-modal-container",
    backdrop: true,
    windowClass: "edit-user-window-class",
  };
  @Output("result") public modalResult: EventEmitter<any> =
    new EventEmitter<boolean>();
  public modalIdInput: string;
  public discountToEdit: BaseDiscountModel;

  public readonly EventFormCustomFormType = EventFormCustomFormType;

  constructor(
    private modalService: NgbModal,
    public activeModal: NgbActiveModal,
    private changeDetector: ChangeDetectorRef
  ) {}

  public _customEventType: "discount" | "editDiscount";

  @Input("customFormType")
  public set customEventType(value: "discount" | "editDiscount") {
    if (value && value !== this._customEventType) {
      this._customEventType = value;
    }
  }

  @Input("modalEventIdInput")
  public set modalEventIdInput(value: string) {
    if (value && value !== this.modalIdInput) {
      this.modalIdInput = value;
    }
  }

  public ngOnInit(): void {
    this.modalIdInput = this.modalIdInput || "new";
    this._customEventType = this._customEventType || "discount";
  }

  public modalClose(result: string) {
    this.activeModal.close(result);
  }

  public modalActionsHandler($event: any) {
    if ($event === "close") {
      this.modalClose(null);
    }
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/discounts/discount-management-form-main-modal-container/discount-management-form-main-modal-container.component.ts